import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-expandable-text',
    templateUrl: './expandable-text.component.html',
    styleUrls: ['./expandable-text.component.scss']
})
export class ExpandableTextComponent {
    @Input() text: string = '';
    @Input() maxLength: number = 250;
    isExpanded: boolean = false;

    toggleExpand() {
        this.isExpanded = !this.isExpanded;
    }
}
